export enum LINK_EDITOR_ROLE {
  input = 'link-editor-input',
  button = 'link-editor-button',
}
